import { useNavigate } from "react-router-dom";
import SignInImage from "../../src/assests/initiallogo1.png";
import Logo from "../../src/assests/logo.png";

export default function SignIn() {
  const navigate = useNavigate();

  const handleSignIn = () => {
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-green-100 flex flex-col justify-between items-center pt-6">
      {/* Logo */}
      <div className="flex justify-center items-center w-full mb-4 pl-12">
        <img src={Logo} alt="logo" className="w-48 sm:w-52 md:w-60 h-auto" />
      </div>

      {/* Illustration */}
      <div className="flex justify-center items-center w-full mb-6 px-4">
        <img src={SignInImage} alt="illustration" className="w-64 sm:w-72 md:w-80 h-auto" />
      </div>

      {/* Welcome Card at Bottom */}
      <div className="bg-green-500 text-white rounded-t-3xl px-6 sm:px-10 md:px-16 pt-8 pb-20 w-full text-center shadow-inner">
        <h2 className="text-2xl sm:text-3xl font-bold mb-4">Welcome, Ohmians!</h2>
        <p className="text-sm sm:text-base leading-relaxed max-w-2xl mx-auto mb-6">
          Your dedication fuels our success. Together, let’s drive innovation, growth, and excellence every single day.
          Thank you for being a valuable part of the OHM family. Let’s continue making every moment count!
        </p>
        <div className="flex justify-center">
          <button
            onClick={handleSignIn}
            className="bg-white text-green-600 font-semibold px-8 py-2 rounded-full shadow-md hover:bg-green-100 transition"
          >
            Sign In
          </button>
        </div>
      </div>
    </div>
  );
}
